import {BaseModel, Address, GeneralAccount} from './index';
import * as AT from '../../components/container/attributes';
import Transaction from './Transaction';

export default class TransactionAccount extends BaseModel {
  constructor({
    id,
    number,
    debit = undefined,
    credit = undefined,
    taxCode = undefined,
    comment = undefined,
    sortOrder = undefined,
    // assignment = undefined,
    //  tallied = undefined,
    transaction = undefined,
    parent = undefined,
    account = undefined,
    address = undefined,
  }) {
    super(id, number);
    (this.debit = debit),
      (this.credit = credit),
      (this.taxCode = taxCode),
      (this.comment = comment),
      (this.sortOrder = sortOrder),
      (this.parent = parent),
      //(this.assignment = assignment), will be uncommented later
      //(this.tallied = undefined);
      (this.address = address ? new Address(address) : undefined);
    this.account = account ? new GeneralAccount(account) : undefined;
    this.transaction = transaction ? new Transaction(transaction) : null;
  }

  static get fkName() {
    return undefined;
  }
  static get apiRoute() {
    return 'transaction_account';
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return TransactionAccount.fkName;
  }
  get apiRoute() {
    return TransactionAccount.apiRoute;
  }
  get listPageRoute() {
    return TransactionAccount.listPageRoute;
  }
  get detailPageRoute() {
    return TransactionAccount.detailPageRoute;
  }

  static get joinAttrsKey() {
    return [
      'account',
      'designation',
      'debit',
      'credit',
      //  'assignment',
      //  'tallied',
      'comment',
    ];
  }

  static get entityListDisplayAttrs() {
    return [
      'designation',
      'debit',
      'credit',
      //  'assignment',
      //  'tallied',
      'comment',
    ];
  }

  static get entityListHiddenAttrs() {
    return ['sortOrder', 'transaction', 'accountId', 'addressId', 'taxCode'];
  }

  static get entityListAttrs() {
    return this.getAttributes(
      this.entityListDisplayAttrs,
      this.entityListHiddenAttrs,
    );
  }

  static get allAttributes() {
    return [
      new AT.FkAccountAttribute({
        name: 'account',
        column: 'account_id',
        joinPath: ['account!fk_transaction_account_account_id_account'],
      }),
      new AT.NotFetchedAttribute({
        name: 'number',
        transform: (data) => {
          if (data.address) {
            return data.address?.number || '';
          }

          return data.account?.number || '';
        },
        tableProperties: {
          header: 'hit-app.common.account',
          maxWidth: '0.5fr',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'designation',
        readOnly: true,

        transform: (data) => {
          if (data.address) {
            return data.address?.designation || '';
          }

          return data.account?.designation || '';
        },

        tableProperties: {
          header: 'hit-base.common.designation',
          maxWidth: '1.5fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'debit',
        column: 'debit',
        decimalPrecision: 2,
        decimalDefaultValue: 0.0,
        tableProperties: {
          header: 'hit-app.transaction.debit',
          maxWidth: '0.6fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'credit',
        column: 'credit',
        decimalPrecision: 2,
        decimalDefaultValue: 0.0,
        tableProperties: {
          header: 'hit-app.transaction.credit',
          maxWidth: '0.6fr',
        },
      }),
      new AT.FkTaxCodeAttribute({
        name: 'taxCode',
        column: 'tax_code_id',
        joinPath: ['tax_code!fk_transaction_account_tax_code_id_tax_code'],
        tableProperties: {
          header: 'hit-app.common.tax-code',
          maxWidth: '0.5fr',
        },
      }),
      new AT.FkTransactionAttribute({
        name: 'transaction',
        column: 'transaction_id',
        joinPath: [
          'transaction!fk_transaction_account_transaction_id_transaction',
        ],
      }),

      new AT.FkAddressAttribute({
        name: 'address',
        column: 'address_id, number, designation',
        joinPath: ['address!fk_transaction_account_address_id_address'],
      }),
      new AT.StringAttribute({
        name: 'comment',
        tableProperties: {
          header: 'hit-base.common.comment',
          maxWidth: '0.75fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
      }),
      /* new AT.IntegerAttribute({ //will be uncommented later
         name: 'assignment',
         column: 'assignment',
         tableProperties: {
           header: 'hit-app.transaction.assignment',
           maxWidth: '0.4fr',
         },
       }),
       new AT.BooleanAttribute({ //will be uncommented later
         name: 'tallied',
         tableProperties: {
           header: 'hit-app.transaction.tallied',
           maxWidth: '4.5rem',
         },
       }),*/
      new AT.StringAttribute({
        name: 'parentId',
        column: 'parent_id',
      }),
    ];
  }
}
